"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClientSearch = void 0;
const react_1 = require("react");
const client_1 = require("@apollo/client");
const apollo_client_utils_1 = require("../../../apollo-client/apollo-client.utils");
const client_utils_1 = require("../client.utils");
const useClientSearch = ({ networkStatus, refetch, executeSearch, abortOnNewSearch = false, }) => {
    const searchAbortControllerRef = (0, react_1.useRef)();
    const handleSearchPromiseError = (0, react_1.useCallback)((error) => {
        if (!(0, apollo_client_utils_1.isAbortError)(error)) {
            // Apollo surfaces non-abort failures through query state.
        }
    }, []);
    (0, react_1.useEffect)(() => () => {
        var _a;
        (_a = searchAbortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
    }, []);
    const onSearch = (0, react_1.useCallback)((newSearchTerm) => {
        var _a, _b;
        const search = newSearchTerm || undefined;
        if (executeSearch) {
            if (abortOnNewSearch) {
                (_a = searchAbortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
                searchAbortControllerRef.current = new AbortController();
            }
            void executeSearch({
                search,
                signal: (_b = searchAbortControllerRef.current) === null || _b === void 0 ? void 0 : _b.signal,
            }).catch(handleSearchPromiseError);
            return;
        }
        if (!refetch) {
            return;
        }
        void refetch({
            search,
            before: null,
            after: null,
        }).catch(handleSearchPromiseError);
    }, [abortOnNewSearch, executeSearch, handleSearchPromiseError, refetch]);
    return {
        onSearch,
        isSearching: executeSearch
            ? (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus)
            : networkStatus === client_1.NetworkStatus.refetch,
    };
};
exports.useClientSearch = useClientSearch;
